import React, { useState } from 'react';
import './forgotPassword.css';
import ApiClient from '../../Services/ApiClient';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email) {
      setError('בבקשה הכנס כתובת מייל');
      return;
    }

    try {
      await ApiClient.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err: any) {
      setError('כשלון בשליחת מייל לאיפוס, אנא נסה שוב.');
    }
  };

  return (
    <div className="forgot-password-container page-padding">
      <h2>איפוס סיסמה</h2>
      {submitted ? (
        <div className="success-message">
          אם קיים מייל למשתמש זה, נשלח קישור לאיפוס סיסמא
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">אימייל:</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button className="btn btn-primary" type="submit">שלח לינק לאיפוס</button>
        </form>
      )}
    </div>
  );
};

export default ForgotPassword;